const ID_PARAMS = '/:id';
const VIN_PARAMS = '/:vin';
const VEHID_PARAMS = '/:vehid';
const TYPE_PARAMS = '/:type';
const TOKEN_PARAMS = '/:token';
const VEHICLE_PARAMS = '/:vehicle';
const DEALER_PARAMS = '/:dealer';

////////////// APP-ROUTES URL ////////////////

export const DASHBOARD_PAGE_PATH = '/';
export const PHOTOGRAPHERS_ACCOUNTS_PAGE_PATH = '/photographersaccount';
export const VIN_STATUS_TRACKER = '/vinstatustracker';
export const VIN_STATUS_TRACKER_PATH_ID = VIN_STATUS_TRACKER + DEALER_PARAMS + VIN_PARAMS;
export const COMPARISION_PAGE_PATH = '/comparison';
export const EDITTRACKER_PAGE_PATH = '/edittracker';
export const MAVIS_PAGE_PATH = '/mavis';
export const EXPORT_PAGE_PATH = '/export';
export const IMPORT_PAGE_PATH = '/import';
export const IMPORT_PAGE_PATH_ID = IMPORT_PAGE_PATH + DEALER_PARAMS;
export const INVENTORY_PAGE_PATH = '/inventory';
export const DEALERPROFILE_PAGE_PATH = '/profile';
export const DEALERPROFILE_PAGE_PATH_ID = DEALERPROFILE_PAGE_PATH + ID_PARAMS;
export const PHOTOGRAPHER_PROFILE_PAGE_PATH = '/photographers';
export const ACCOUNTS_PAGE_PATH = '/accounts';

export const QUALITY_CONTROL_PAGE_PATH = '/qc';
export const QUALITY_CONTROL_EDITFLAGS_PAGE_PATH = '/qceditsflags';
export const VIDEO_PAGE_PATH = '/video';
export const INSTA360_PAGE_PATH = '/insta360';
export const EXT360_PAGE_PATH = '/ext360';
export const FILEMANAGER_PAGE_PATH = '/filemanager';
export const PAGUIDES_PAGE_PATH = '/dealershots';
export const EXPORT_ORDER_PAGE_PATH = '/reordershots';
export const MAVIS_SETTINGS_PAGE_PATH = '/mavissettings';
export const RATIO_SETTINGS_PAGE_PATH = '/ratiosettings';
export const MASTER_COMPOSITIONS_PAGE_PATH = '/mastershots';
export const DEFAULT_GUIDES_PAGE_PATH = '/defaultcomposition';
export const MAVIS_PRESENTS_PAGE_PATH = '/presets';
export const FEATURE_ICONS_PAGE_PATH = '/feature';
export const FLAGS_PAGE_PATH = '/flags';
export const BODYSTYLES_PAGE_PATH = '/bodytypes';
export const APIKEYS_PAGE_PATH = '/apikeys';
export const VIDEOGENERATION_PAGE_PATH = '/videogeneration';
export const YOUTUBE_THUMBNAIL_PAGE_PATH = '/youtubethumbnail';
export const FEATURE_BANNERS_PAGE_PATH = '/featurebanners';
export const FEATURE_BANNERS_SETTINGS_PAGE_PATH = '/bannersettings';
export const REPORTSETTINGS_PAGE_PATH = '/reportsettings';
export const EDITOR_REPORT_PAGE_PATH = '/editorreport';

export const TTM_PAGE_PATH = '/ttm';
export const INVOICING_PAGE_PATH = '/invoice';
export const ACCOUNTING_REPORT_PAGE_PATH = '/accountreport';
export const ACCOUNTING_INVOICE_SETTINGS_PAGE_PATH = '/invoicesettings';
export const ADMINLOGS_PAGE_PATH = '/adminlog';
export const SALES_PAGE_PATH = '/sales';
export const SALES_SLIDER_PAGE_PATH_VEHICLE = SALES_PAGE_PATH + VEHICLE_PARAMS;
export const DEALERLOG_PAGE_PATH = '/dealerlog';
export const CRONSTATS_PAGE_PATH = '/cronstats';
export const OURMISSION_PAGE_PATH = '/ourmission';
export const NOTIFICATIONS_PAGE_PATH = '/notifications';
export const NOTIFICATIONS_PAGE_PATH_ID = NOTIFICATIONS_PAGE_PATH + ID_PARAMS;
export const USERPROFILE_PAGE_PATH = '/userprofile';
export const USERPROFILE_PAGE_PATH_ID = USERPROFILE_PAGE_PATH + ID_PARAMS;
export const TEAMPROFILE_PAGE_PATH = '/team';
export const TEAMPROFILE_PAGE_PATH_ID = TEAMPROFILE_PAGE_PATH + ID_PARAMS;
export const VEHICLE_GALLERY_PAGE_PATH = '/vehdisplay';
export const VEHICLE_GALLERY_PAGE_PATH_VIN = VEHICLE_GALLERY_PAGE_PATH + VIN_PARAMS;
export const BGERROR_GALLERY_PAGE_PATH = '/bgerror';
export const BGERROR_GALLERY_PAGE_PATH_VEHID = BGERROR_GALLERY_PAGE_PATH + VEHID_PARAMS;
export const MAVIS_GALLERY_PAGE_PATH = '/mavisvehicle';
export const MAVIS_GALLERY_PAGE_PATH_DEALER_VEH_VIN =
  MAVIS_GALLERY_PAGE_PATH + DEALER_PARAMS + VEHICLE_PARAMS + VIN_PARAMS;
export const CONFIRMVDS_GALLERY_PAGE_PATH = '/confirmvds';
export const CONFIRMVDS_GALLERY_PAGE_PATH_TYPEVIN = CONFIRMVDS_GALLERY_PAGE_PATH + TYPE_PARAMS + VIN_PARAMS;
export const INVENTORY_DETAILS_PAGE_PATH = '/inventoryDetails';
export const INVENTORY_DETAILS_PAGE_PATH_TYPE = INVENTORY_DETAILS_PAGE_PATH + ID_PARAMS + DEALER_PARAMS;

export const LOGIN_PAGE_PATH = '/auth/login';
export const OTPVERIFY_PAGE_PATH = '/auth/verifyotp';
export const FORGOT_PASSWORD_PAGE_PATH = '/auth/forgot';
export const RESET_PASSWORD_PAGE_PATH = '/auth/reset';
export const RESET_PASSWORD_PAGE_PATH_TOKEN = RESET_PASSWORD_PAGE_PATH + TOKEN_PARAMS;
export const MAINTANANCE_PAGE_PATH = '/maintainance';
export const ERROR403_PAGE_PATH = '/403';
export const ERROR404_PAGE_PATH = '/404';

export const PHOTON360_VIEWER_PAGE_PATH = '/viewer';
export const DEVELOPER_ACCESS_PAGE_PATH = '/developer-access';
export const PHOTON360_VIEWER_PAGE_FULL_PATH = '/viewer/:dealer_id/:vin';

export const AUTOEDIT_VEHICLE_GALLERY_PAGE_PATH = '/autoedit/gallery/:vin';

export const EDITORPROFILE_PAGE_PATH = '/editorprofile';
export const INTEGRATION_PAGE_PATH = '/integration';
export const THEME_DOCS_PAGE_PATH = '/themedocs';

export const RETRO_OPERATIONS_PATH = '/retrooperations';
export const FAQ_PATH = '/faq';
export const KUDOS_PATH = '/kudos';
export const PROMO_BANNERS_PAGE_PATH = '/promobanners';
export const PROMO_BILLBOARDS_PAGE_PATH = '/promobillboards';

export const EXPORT_DMS_PATH = '/exportdms';
export const IMPORT_DMS_PATH = '/importdms';
export const REPORT_STATISTICS_PATH = '/reportstatistics';
export const ANNOUNCEMENT_BANNER_PAGE_PATH = '/announcementsbanner';

export const USER_ROLES_PATH = '/userroles';
export const AUTOPORT_SETTINGS_PAGE_PATH = '/apsettings';
export const PROMO_BANNER_FAQ_PATH = '/promobannerfaqs';

export const LSP_RATE_PATH = '/lsp-rate';
export const LSP_INVOICES_PATH = '/lsp-invoices';
export const WINDOW_STICKER_DASHBOARD_PATH = '/window-sticker-dashboard';
export const PRINT_QUEUE_PATH = '/print-queue';
export const WINDOW_STICKER_PRICING_PATH = '/window-sticker-pricing';
export const VIN_TURNAROUND_PAGE_PATH = '/vin-turnaround';
export const VEH_UPLOAD_HISTORY_PAGE_PATH = '/vehicle-upload-history';
export const REMOVEBG_PLAYGROUND_PATH = '/background-removal-playground';
